/**
 * Set up handling weather API requests.
 * Opens a modal from the bottom of the page when pin is clicked.
 */

const createPinModal = (name, info, lon, lat) => {
  let lonRounded = Math.round(lon * 100) / 100;
  let latRounded = Math.round(lat * 100) / 100;

  let formattedInfo = `<ul class="no-bullets">`

  for (const [key, value] of Object.entries(info)) {
    let field = value;
    if (field === null){
      field = "N/A"
    } else if (typeof(field) === "string" && field.includes("http")){
      field = `<a href="${field}">${field}</a>`
    } else if (typeof(field) === "string" && field.includes("@")){
      field = `<a href="mailto:${field}">${field}</a>`
    }
    formattedInfo += `<li>${key}: ${field}</li> `
  }

  formattedInfo += "</ul>"

  const fullContent =  { 
    name: name,
    weather: `<a href="https://clearoutside.com/forecast/${lat}/${lon}">
    <img style = "display: block; margin-left: auto; margin-right: auto; width: 90%;" class="img-fluid" 
    src="https://clearoutside.com/forecast_image_medium/${latRounded}/${lonRounded}/forecast.png"
    onerror="this.onerror = null; this.src = 'https://clearoutside.com/forecast_image_medium///forecast.png'" /></a>`,
    info: `${formattedInfo}`
  }

  return fullContent;
  ;
};

export { createPinModal };
